<div class="flex h-full flex-col bg-white">
    <div class="flex h-16 flex-none items-center justify-center">
        <ion-button class="absolute left-0" (click)="handleBackArrow()" color="primary" fill="clear">
            <ion-icon
                class="var-app-light:text-primary mr-1 text-xl text-secondary dark:filter-yellow"
                src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg"></ion-icon>
        </ion-button>

        <h1 class="vl-app-light:font-bold var-app-light-dark:font-bold mx-1 text-base font-semibold">
            {{ 'CHANGE_PASSWORD' | translate }}
        </h1>
    </div>
    <hr class="item-separator m-0" />
    <form
        class="var-app-light-dark:pt-6 flex flex-1 flex-col p-4"
        [formGroup]="passwordForm"
        (ngSubmit)="submitPassword()"
        ridangoFocusInvalidInput>
        <div class="input_data">
            <input formControlName="username" ridangoInput name="username" type="hidden" />

            <mat-form-field class="full-width text-black dark:text-contrast-yellow" appearance="outline">
                <mat-label
                    [attr.aria-label]="'PH_OLD_PASSWORD' | translate"
                    title="{{ 'PH_OLD_PASSWORD' | translate }}"
                    >{{ 'PH_OLD_PASSWORD' | translate }}</mat-label
                >
                <input
                    id="password"
                    [type]="showOldPassword ? 'text' : 'password'"
                    [attr.aria-label]="'PH_OLD_PASSWORD' | translate"
                    formControlName="password"
                    title="{{ 'PH_OLD_PASSWORD' | translate }}"
                    matInput
                    ridangoInput
                    required
                    ridangoUntouchOnFocusout />
                <div class="mr-3 flex items-center justify-center gap-5" matSuffix>
                    <button
                        class="gl-light:text-[var(--color-secondary)] show-pw-btn text-primary"
                        [attr.aria-label]="'HIDE_PASSWORD_ARIA_LABEL' | translate"
                        [attr.aria-pressed]="showOldPassword"
                        (click)="showOldPassword = !showOldPassword"
                        matSuffix
                        type="button">
                        <mat-icon class="orb-app-light:text-secondary">{{
                            showOldPassword ? 'visibility' : 'visibility_off'
                        }}</mat-icon>
                    </button>
                </div>
                <mat-error
                    *ngIf="
                        passwordForm.controls.password.touched && passwordForm.controls.password.hasError('required')
                    ">
                    {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width text-black dark:text-contrast-yellow" appearance="outline">
                <mat-label
                    [attr.aria-label]="'PH_NEW_PASSWORD' | translate"
                    title="{{ 'PH_NEW_PASSWORD' | translate }}"
                    >{{ 'PH_NEW_PASSWORD' | translate }}</mat-label
                >
                <input
                    id="newPassword"
                    [type]="showNewPassword ? 'text' : 'password'"
                    [attr.aria-label]="'PH_NEW_PASSWORD' | translate"
                    formControlName="newPassword"
                    title="{{ 'PH_NEW_PASSWORD' | translate }}"
                    matInput
                    ridangoInput
                    required
                    ridangoUntouchOnFocusout />
                <div class="mr-3 flex items-center justify-center gap-5" matSuffix>
                    <button
                        class="gl-light:text-[var(--color-secondary)] text-primary"
                        [attr.aria-label]="'HIDE_PASSWORD_ARIA_LABEL' | translate"
                        [attr.aria-pressed]="showNewPassword"
                        (click)="showNewPassword = !showNewPassword"
                        matSuffix
                        type="button">
                        <mat-icon class="orb-app-light:text-secondary">{{
                            showNewPassword ? 'visibility' : 'visibility_off'
                        }}</mat-icon>
                    </button>
                </div>

                <mat-hint id="change-password-requirements-hint">
                    <ridango-ui-mat-list-hint
                        titleTerm="PASSWORD_REQUIREMENT_HINT_TITLE"
                        listTerm="PASSWORD_REQUIREMENT_HINT_LIST">
                    </ridango-ui-mat-list-hint>
                </mat-hint>

                <mat-error
                    *ngIf="passwordForm.controls['newPassword'].touched"
                    [ngSwitch]="
                        getFirstError(passwordForm.controls.newPassword, ['required', 'minlength', 'numberRequired'])
                    ">
                    <ng-container *ngSwitchCase="'required'">
                        {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'minlength'">
                        {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'numberRequired'">
                        {{ 'LOCAL_INPUT_PASSWORD_MISSING_NUMBER_LENGTH' | translate }}
                    </ng-container>
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width text-black dark:text-contrast-yellow" appearance="outline">
                <mat-label
                    [attr.aria-label]="'PH_NEW_PASSWORD_AGAIN' | translate"
                    title="{{ 'PH_NEW_PASSWORD_AGAIN' | translate }}"
                    >{{ 'PH_NEW_PASSWORD_AGAIN' | translate }}</mat-label
                >
                <input
                    id="newPasswordAgain"
                    [type]="showNewPasswordRepeat ? 'text' : 'password'"
                    [attr.aria-label]="'PH_NEW_PASSWORD_AGAIN' | translate"
                    formControlName="newPasswordAgain"
                    title="{{ 'PH_NEW_PASSWORD_AGAIN' | translate }}"
                    matInput
                    ridangoInput
                    required
                    ridangoUntouchOnFocusout />
                <div class="mr-3 flex items-center justify-center gap-5" matSuffix>
                    <button
                        class="gl-light:text-[var(--color-secondary)] text-primary"
                        [attr.aria-label]="'HIDE_PASSWORD_ARIA_LABEL' | translate"
                        [attr.aria-pressed]="showNewPasswordRepeat"
                        (click)="showNewPasswordRepeat = !showNewPasswordRepeat"
                        matSuffix
                        type="button">
                        <mat-icon class="orb-app-light:text-secondary">{{
                            showNewPasswordRepeat ? 'visibility' : 'visibility_off'
                        }}</mat-icon>
                    </button>
                </div>
                <mat-error
                    *ngIf="passwordForm.controls.newPasswordAgain.touched"
                    [ngSwitch]="
                        getFirstError(passwordForm.controls.newPasswordAgain, [
                            'required',
                            'minlength',
                            'numberRequired'
                        ])
                    ">
                    <ng-container *ngSwitchCase="'required'">
                        {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'minlength'">
                        {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'numberRequired'">
                        {{ 'LOCAL_INPUT_PASSWORD_MISSING_NUMBER_LENGTH' | translate }}
                    </ng-container>
                </mat-error>
            </mat-form-field>
        </div>

        <div class="submit_wrapper flex h-full min-h-[20vh] flex-col justify-end pb-8">
            <div class="w-full">
                <div>
                    <button
                        class="vl-app-light:bg-[var(--btn-primary-color)] flex-align-center vl-app-light:text-black var-app-light:text-black orb-app-light:text-black orb-app-light:bg-primary flex h-14 w-full justify-center rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                        type="submit">
                        <ion-label class="flex-align-center flex text-base font-bold normal-case">
                            {{ 'BTN_CHANGE_PASSWORD' | translate }}
                        </ion-label>
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
